module.exports = __webpack_public_path__ + "img/191.132ab58d.jpg";